import React from 'react'


const AppDesc = ({text}) => {
    return (
        <div className='desc'>
            <p>{text}</p>
        </div>
    )
}

export default AppDesc